import cronstrue from 'cronstrue';
import 'cronstrue/locales/pl';

/**
 * Returns a human-readable (Polish) description of a cron expression, or
 * `null` if the expression is empty/invalid (cronstrue throws on invalid input).
 */
export function describeCron(cronExpression: string): string | null {
  const trimmed = cronExpression.trim();
  if (!trimmed) return null;
  try {
    return cronstrue.toString(trimmed, { locale: 'pl' });
  } catch {
    return null;
  }
}
